import { AppLogger, DynatraceClient } from '@workivate/tho-web-shared';
import { initialiseDynatrace, loadDynatraceScript } from './dynatrace-helpers';

/**
 * Loads the Dynatrace script, initialises DynatraceClient, and wires AppLogger
 * to route logs to Dynatrace as events/exceptions.
 *
 * Must be called after getCorrelationId() so the correct correlation ID is
 * already in localStorage when DynatraceClient.init() reads it.
 */
export const setupDynatrace = async (scriptUrl: string): Promise<void> => {
  await loadDynatraceScript(scriptUrl);
  initialiseDynatrace();
  AppLogger.configure({
    isProduction: IS_PRODUCTION,
    dynatraceLogger: (message, context = {}) => {
      if (context['error']) {
        DynatraceClient.sendException(new Error(context['error']), {
          logmessage: message,
          ...(context['loglevel'] && { loglevel: context['loglevel'] }),
        });
      }

      DynatraceClient.sendEvent('frontend.log', {
        logmessage: message,
        ...(context['loglevel'] && { loglevel: context['loglevel'] }),
      });
    },
  });
};
